import { streamingApi } from "./base.api";

import { ApprovalDataChangeSet } from "types/ApprovalDataChangeSet";

const BASE_PATH = "/approval";

export const approvalApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getApprovalDataChangeSet: build.query<ApprovalDataChangeSet, string>({
            query: (approvalDataChangeSetId) =>
                `${BASE_PATH}/ApprovalDataChangeSets/${approvalDataChangeSetId}`,
        }),
    }),
    overrideExisting: true,
});

export const { useGetApprovalDataChangeSetQuery } = approvalApi;
